// @flow

import { constants } from '@clubmed/utils';

import { DESTINATIONS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_DESTINATIONS } from 'Utils/request/requestDictionary';
import { getPriceFields, cleanupArgs } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import * as configQueries from 'Views/configQueries';

const { PRODUCT_TYPES } = constants;

export type DestinationMedia = {|
  id: string,
  mediaUrl: string,
  link: string,
|};

export type TopDestinations = {
  label: string,
  destinations: Array<{
    [string]: DestinationMedia,
  }>,
};

export type DestinationArea = {
  id: string,
  countries: Array<DestinationMedia>,
};

export type CMSProps = {|
  title: string,
  id: string,
  seeAllDestinationsLink: {
    label: string,
    url: string,
  },
  viewMapLink: {
    label: string,
    url: string,
  },
  topDestinations: TopDestinations,
  areas: Array<DestinationArea>,
|};

export type DestinationPrice = {|
  bestPrice: FormattedPrice,
  currency: string,
  initialPrice: FormattedPrice,
  termsAndConditions: TermsAndConditions,
  unit: string,
|};

export type Destinations = Array<{
  id: string,
  label: string,
  countries: Array<{
    id: string,
    label: string,
    products: Array<{
      id: string,
      type: string,
      href: null | string,
      price: null | DestinationPrice,
    }>,
  }>,
}>;

export type GQLProps = {|
  config: { price: { format: { from: string } } },
  destinations: Destinations,
  productType: string,
|};

export const destinationsResolver = {
  name: DESTINATIONS,
  resolve: async (appContext: AppContext): Promise<GQLProps> => {
    const query = `query {
      config {
        common {
          close
          scrollBackward
          scrollForward
        }
        ${configQueries.price()}
        ${configQueries.resort(appContext)}
      }
      destinations(productType: "${PRODUCT_TYPES.RESORT}") {
        id
        label
        countries {
          id
          label
          products {
            id
            type
            href
            ${getPriceFields(cleanupArgs({}))}
          }
        }
      }
    }`;

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: LINE_COMMON_DESTINATIONS,
      })
      .then(data => ({ ...data, productType: PRODUCT_TYPES.RESORT }));
  },
};
